import React, { useState, useEffect } from 'react';
import apiHelper from '../utils/apiHelper';
import { useProfile } from '../contexts/ProfileContext';
import './ExportOptionsModal.css';

const ExportOptionsModal = ({ isOpen, onClose, onExport, exportType }) => {
    const { profile } = useProfile();
    const [selectedMode, setSelectedMode] = useState('full');
    const [isExporting, setIsExporting] = useState(false);

    useEffect(() => {
        if (isOpen && profile?.email) {
            apiHelper.logModalOpen(profile.email, 'ExportOptionsModal', exportType || 'Export', 'Export');
        }
    }, [isOpen, profile?.email]);

    if (!isOpen) return null;

    const handleExport = async () => {
        setIsExporting(true);
        try {
            await onExport(selectedMode);
        } finally {
            setIsExporting(false);
            onClose();
        }
    };

    const getTitle = () => {
        switch (exportType) {
            case 'pdf': return 'Export to PDF';
            case 'word': return 'Export to Word';
            case 'powerpoint': return 'Export to PowerPoint';
            default: return 'Export Options';
        }
    };

    const getExportingLabel = () => {
        const format = exportType === 'powerpoint' ? 'PowerPoint' : exportType === 'word' ? 'Word' : 'PDF';
        return `Generating ${format}...`;
    };

    return (
        <div className="export-options-modal-overlay" onClick={isExporting ? undefined : onClose}>
            <div className="export-options-modal" onClick={(e) => e.stopPropagation()}>
                <div className="export-options-header">
                    <h3>{isExporting ? getExportingLabel() : getTitle()}</h3>
                    {!isExporting && (
                        <button className="export-options-close" onClick={onClose}>×</button>
                    )}
                </div>

                {isExporting ? (
                    <div className="export-options-content export-loading">
                        <div className="export-spinner"></div>
                        <p className="export-loading-text">
                            {exportType === 'powerpoint'
                                ? 'Daire is structuring your conversation into slides...'
                                : 'Preparing your document...'}
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="export-options-content">
                            <p className="export-options-description">
                                Choose the type of export you'd like to generate:
                            </p>

                            <div className="export-options-radio-group">
                                <label className="export-option-item">
                                    <input
                                        type="radio"
                                        name="exportMode"
                                        value="full"
                                        checked={selectedMode === 'full'}
                                        onChange={(e) => setSelectedMode(e.target.value)}
                                    />
                                    <div className="export-option-details">
                                        <strong>Full Content</strong>
                                        <span className="export-option-desc">
                                            Complete conversation with all questions, answers, and formatting
                                        </span>
                                    </div>
                                </label>

                                <label className="export-option-item">
                                    <input
                                        type="radio"
                                        name="exportMode"
                                        value="summary"
                                        checked={selectedMode === 'summary'}
                                        onChange={(e) => setSelectedMode(e.target.value)}
                                    />
                                    <div className="export-option-details">
                                        <strong>Summary</strong>
                                        <span className="export-option-desc">
                                            AI-generated summary of key points and main topics discussed
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="export-options-footer">
                            <button className="export-options-btn export-options-btn-cancel" onClick={onClose}>
                                Cancel
                            </button>
                            <button className="export-options-btn export-options-btn-export" onClick={handleExport}>
                                Export
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ExportOptionsModal;
